var __webpack_exports__ = {};
/*!***************************!*\
  !*** ./src/js/loading.js ***!
  \***************************/
(function () {
  var preload = document.getElementById("preloader");
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  var loading = 0;
  var id = setInterval(function () {
    if (loading == 70) {
      clearInterval(id);
    } else {
      loading = loading + 1;
      if (!isMobile) {
        if (loading == 30) {
          hidePreloader();
        }
      } else if (isMobile && loading == 70) {
        hidePreloader();
      }
    }
  }, 50);
  function hidePreloader() {
    preload.style.transition = "opacity 0.8s ease";
    preload.style.opacity = 0;
    setTimeout(function () {
      preload.style.display = "none";
    }, 800);
  }
})();
